//=> https://developers.google.com/analytics/devguides/collection/ga4/reference/events#add_shipping_info

class SelectShippingEventListener {
    // Language: javascript
    // Path: SelectShippingEventListener.js
    // Compare this snippet from EventListener.js:

    get ShippingName() {
        return ".gtm-shipping-info";
    }
    get CheckoutProducts() {
        return ".gtm-checkout-products";
    }
    get CheckoutCart() {
        return ".gtm-checkout-cart";
    }
    get DefaultEventName() {
        return "click";
    }

    constructor(
        element,
        eventName = SelectShippingEventListener.prototype.DefaultEventName
    ) {
        this.element = element;
        this.eventName = eventName;
    }
    callback() {
        const dataLayer = new DataLayer();
        dataLayer.clear();
        var shippingName;
        var totalPrice;
        var items = [];
        var currency;

        var shippings = document.querySelectorAll(
            SelectShippingEventListener.prototype.ShippingName
        );
        var checkoutProducts = document.querySelectorAll(
            SelectShippingEventListener.prototype.CheckoutProducts
        );

        for (let index = 0; index < shippings.length; index++) {
            if (shippings[index].checked) {
                shippingName = shippings[index].dataset.cargo;
            }
        }

        var checkoutCart = document.querySelector(
            SelectShippingEventListener.prototype.CheckoutCart
        );

        for (var i = 0; i < checkoutProducts.length; i++) {
            var cartItem = checkoutProducts[i];
            var analyticsData = cartItem.dataset.analytics
                ? JSON.parse(cartItem.dataset.analytics)
                : null;

            if (analyticsData && cartItem.dataset) {
                var analticsDataProducts = analyticsData.products
                    ? analyticsData.products[0]
                    : null;
                totalPrice = checkoutCart.dataset.carttotal;
                currency = checkoutCart.dataset.cartcurrency;

                var item = {
                    item_id: analticsDataProducts.code,
                    item_name: analticsDataProducts.name,
                    item_brand: analticsDataProducts.brand,
                    item_category: analticsDataProducts.category,
                };

                if (analticsDataProducts.categories) {
                    var splitCategories =
                        analticsDataProducts.categories.split(";");
                    for (var j = 0; j < splitCategories.length; j++) {
                        if (j == 0) {
                            item["item_category"] = splitCategories[j];
                        } else {
                            item["item_category" + j] = splitCategories[j];
                        }
                    }
                }

                items.push(item);
            }
        }

        if (items.length > 0) {
            SendData(dataLayer);
        }

        function SendData(dataLayer) {
            dataLayer
                .push({
                    event: "add_shipping_info",
                    ecommerce: {
                        currency: currency,
                        value: totalPrice,
                        shipping_tier: shippingName,
                        items: items,
                    },
                })
                .then(() => {
                    setTimeout(() => {
                        var instanceActivate = new ActivateGtm();
                        instanceActivate.activateChangeShipping(false);
                    }, 1000);
                    console.log("GTM pushed add_shipping_info event");
                })
                .catch((error) => {
                    console.warn("GTM error add_shipping_info event", error);
                });

            if (typeof gtag !== "undefined" && !!gtag) {
                gtag("event", "add_shipping_info", {
                    event_category: "Enhanced Ecommerce",
                    event_label: "add shipping info",
                    value: totalPrice,
                    currency: currency,
                    shipping_tier: shippingName,
                    items: items,
                });
            }
        }
    }

    listen() {
        this.element.addEventListener(
            this.eventName,
            SelectShippingEventListener.prototype.callback
        );
    }

    remove() {
        this.element.removeEventListener(
            this.eventName,
            SelectShippingEventListener.prototype.callback
        );
    }
}
